<style scoped>
.signup-container {
	max-width: 900px;
	margin: 0 auto;
}
.signup-box {
	box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
	border-radius: 10px;
	overflow: hidden;
}
.signup-form-section {
	padding: 40px;
}
.signup-info-section {
	padding: 40px;
	background-color: #f8f9fa;
}
.signup-header {
	margin-bottom: 25px;
}
.logo-area {
	text-align: center;
	margin-bottom: 30px;
}
.contact-link {
	font-weight: 600;
	text-decoration: none;
}
</style>
<template>
	<div
		class="container min-vh-100 d-flex align-items-center justify-content-center py-5"
	>
		<div class="signup-container">
			<div class="row signup-box g-0">
				<!-- Left side: Signup Info -->
				<div class="col-md-6 signup-form-section">
					<div class="signup-header">
						<h2>Signup</h2>
						<p class="text-muted">
							Get started with Nidus for your mosquito control district
						</p>
					</div>

					<p>
						Nidus accounts are provisioned for mosquito control districts and
						their authorized personnel. Open self-registration is not
						available.
					</p>

					<div class="card bg-light border-0 mb-3">
						<div class="card-body">
							<h6 class="card-title">
								<i class="bi bi-currency-dollar"></i> Get a Quote
							</h6>
							<p class="card-text small text-muted mb-1">
								To get started, reach out to our sales team for a quote tailored
								to your district.
							</p>
							<a
								href="mailto:sales@gleipnir.technology"
								class="contact-link"
							>
								<i class="bi bi-envelope"></i> sales@gleipnir.technology
							</a>
						</div>
					</div>

					<div class="card bg-light border-0 mb-4">
						<div class="card-body">
							<h6 class="card-title">
								<i class="bi bi-question-circle"></i> Already a Customer?
							</h6>
							<p class="card-text small text-muted mb-1">
								If you're unsure whether your district already has an account,
								or need help accessing it, contact our support team.
							</p>
							<a
								href="mailto:support@gleipnir.technology"
								class="contact-link"
							>
								<i class="bi bi-envelope"></i> support@gleipnir.technology
							</a>
						</div>
					</div>

					<div class="text-center">
						<p>
							Already have an account?
							<RouterLink to="/signin">Sign in</RouterLink>
						</p>
					</div>
				</div>

				<!-- Right side: Platform Info -->
				<div class="col-md-6 signup-info-section">
					<div>
						<div class="logo-area">
							<img src="/static/img/nidus-logo-256-transparent.png" />
						</div>

						<div class="mb-4">
							<h5>What is Nidus?</h5>
							<p>
								Nidus is an integrated mosquito control platform purpose-built
								for abatement districts. It brings together field data
								collection, aerial surveillance, treatment tracking, and
								public reporting in a single system.
							</p>
						</div>

						<div class="mb-4">
							<h5>Who is it for?</h5>
							<p>
								Nidus serves mosquito control districts of all sizes. From
								small rural operations to large metropolitan programs, our
								tools adapt to your workflow and help you make data-driven
								decisions.
							</p>
						</div>

						<div class="mb-3">
							<small class="text-muted">
								For any questions about the platform or to schedule a demo,
								reach out to us at
								<a href="mailto:sales@gleipnir.technology"
									>sales@gleipnir.technology</a
								>
							</small>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import { RouterLink } from "vue-router";
</script>
